const elementsWithJsCountClass = document.querySelectorAll(".js-limit");

elementsWithJsCountClass.forEach(element => {
  const str = element.textContent;
  const len = 160; // 半角40字（全角約160字）
  if (str.length > len) {
    element.textContent = str.substring(0, len) + "…";
  }
});
